import { render } from "./AccessDeniedView.vue?vue&type=template&id=5a288ad6&scoped=true"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"

import "./AccessDeniedView.vue?vue&type=style&index=0&id=5a288ad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a288ad6"]])

export default __exports__